import { HttpParams } from '@angular/common/http'
import { ChangeDetectorRef, Component, effect, inject, input } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { WjGridModule } from '@grapecity/wijmo.angular2.grid'
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'

import { BaseComponent, Grid, ListItem } from '../../../shared'
import { ActionToolbarCount } from '../../../shared/reusable-components/action-toolbar-count/action-toolbar-count.component'
import { GridColumnGroupComponent } from '../../../shared/reusable-components/grid-column-group/grid-column-group.component'
import { GridExportComponent } from '../../../shared/reusable-components/grid-export/grid-export.component'
import { GridSelectionCalculationComponent } from '../../../shared/reusable-components/grid-selection-calculation/grid-selection-calculation.component'
import { AutoSizeDirective } from '../../../shared/utility/auto-size.directive'

@Component({
    selector: 'app-burn-rate',
    templateUrl: './burn-rate.component.html',
    standalone: true,
    imports: [
        FormsModule,
        WjInputModule,
        WjGridModule,
        WjGridFilterModule,
        GridColumnGroupComponent,
        GridSelectionCalculationComponent,
        GridExportComponent,
        ActionToolbarCount,
        AutoSizeDirective,
    ],
})
export class BurnRateComponent extends BaseComponent {
    active = input.required<number>()
    cdr = inject(ChangeDetectorRef)

    optionsFetched = false

    yearOptions: ListItem<number>[] = []
    selectedYear!: number

    monthOptions: ListItem<number | null>[] = []
    selectedMonth: number | null = null

    dayOptions: ListItem<number | null>[] = []
    selectedDay: number | null = null

    burnRateGrid: Grid<any>

    constructor() {
        super()

        this.burnRateGrid = new Grid<any>(this.services)

        this.buildMonthOptions()

        effect(() => {
            if (this.active() === 12) {
                this.refreshOptions()
            }
        })
    }

    refreshOptions() {
        if (this.optionsFetched) return
        this.cancelableRequest(
            'GetBurnRateOptions',
            true,
            this.services.data.load(true, true, this.services.data.get('/api/FuelAnalytics/GetBurnRateOptions')).subscribe({
                next: result => {
                    this.optionsFetched = true
                    this.yearOptions = result[0].map((x: number) => new ListItem(x, x.toString()))
                    if (this.yearOptions.length > 0) {
                        this.selectedYear = this.yearOptions[0].value
                    }
                    this.cdr.detectChanges()
                    this.refresh()
                },
            }),
        )
    }

    buildMonthOptions() {
        const months = [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December',
        ]
        this.monthOptions = [new ListItem<number | null>(null, 'All Months')]
        months.forEach((name, index) => {
            this.monthOptions.push(new ListItem<number | null>(index + 1, name))
        })
    }

    buildDayOptions() {
        this.dayOptions = [new ListItem<number | null>(null, 'All Days')]
        if (this.selectedMonth != null && this.selectedYear) {
            const daysInMonth = new Date(this.selectedYear, this.selectedMonth, 0).getDate()
            for (let d = 1; d <= daysInMonth; d++) {
                this.dayOptions.push(new ListItem<number | null>(d, d.toString()))
            }
        }
    }

    onYearChange() {
        this.selectedMonth = null
        this.selectedDay = null
        this.buildDayOptions()
        this.refresh()
    }

    onMonthChange() {
        this.selectedDay = null
        this.buildDayOptions()
        this.refresh()
    }

    onDayChange() {
        this.refresh()
    }

    refresh() {
        if (!this.selectedYear) return
        let params = new HttpParams().set('year', this.selectedYear.toString())
        if (this.selectedMonth != null) {
            params = params.set('month', this.selectedMonth.toString())
        }
        if (this.selectedDay != null) {
            params = params.set('day', this.selectedDay.toString())
        }

        this.cancelableRequest(
            'GetBurnRate',
            true,
            this.services.data
                .load(true, true, this.services.data.get('/api/FuelAnalytics/GetBurnRate', params))
                .subscribe({
                    next: result => {
                        this.burnRateGrid.items = result[0]
                    },
                }),
        )
    }
}
